/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Wakil_OkInputs */

const en_tut_wakil_ok = /** @type {(inputs: Tut_Wakil_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whoever contacted you gets a reply from the Digital Deputy in the same thread, and its action shows up in your inbox.`)
};

const id_tut_wakil_ok = /** @type {(inputs: Tut_Wakil_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekan yang menghubungi Anda mendapat balasan dari Wakil Digital di thread yang sama, dan tindakannya muncul di Inbox Anda.`)
};

/**
* | output |
* | --- |
* | "Whoever contacted you gets a reply from the Digital Deputy in the same thread, and its action shows up in your inbox." |
*
* @param {Tut_Wakil_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_wakil_ok = /** @type {((inputs?: Tut_Wakil_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Wakil_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_wakil_ok(inputs)
	return en_tut_wakil_ok(inputs)
});